import { ButtonGhost, ButtonSolid, Heading, Text } from 'ui/components/primitives';
import { styled, theme } from 'ui/theme';

export const CreditCardForm = {
  ButtonChangePayment: styled(ButtonSolid)`
    background: ${theme.colors.action.navigation.standard.static};
    color: ${theme.colors.build.lightLight};
    margin-top: ${theme.space[4]};
  `,

  ButtonToHome: styled(ButtonGhost)`
    color: ${theme.colors.action.navigation.standard.static};
    margin-top: ${theme.space[4]};
  `,

  Component: styled('div')`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: ${theme.space[4]};
  `,

  IconWrapper: styled('div')`
    color: #de1616;
    display: block;
  `,

  Title: styled(Heading)`
    color: ${theme.colors.build.brand1};
    display: block;
    margin-bottom: ${theme.space[3]};
  `,

  Subtitle: styled(Text)`
    color: ${theme.colors.build.darkLight};
    display: block;
    margin-bottom: ${theme.space[2]};
  `,
};
